import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'

import ShowcasePageEdit from '@/components/showcase_generator/ShowcasePageEdit.vue'
import ShowcasePageTable from '@/components/showcase_generator/ShowcasePageTable.vue'
import PublicShowcase from '@/components/showcase_generator/PublicShowcase.vue'
import ExploreDetail from '@/components/explore/ExploreDetail.vue'
import ProcessingSteps from '@/views/ProcessingSteps.vue'
import ShowcaseTemplatesTable from '@/views/ShowcaseTemplatesTable.vue'
import ShowcaseTemplateEdit from '@/components/showcase_generator/templates/ShowcaseTemplateEdit.vue'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/account/showcase/create/',
      name: 'account-showcase-create',
      component: ProcessingSteps
    },
    {
      path: '/site-admin/showcase/create/',
      name: 'site-admin-showcase-create',
      component: ProcessingSteps
    },
    {
      path: '/account/showcase/:slug',
      name: 'account-showcase-edit',
      component: ShowcasePageEdit,
      props: { isSiteAdmin: false }
    },
    {
      path: '/account/showcase/',
      name: 'account-showcase-table',
      component: ShowcasePageTable
    },
    {
      path: '/site-admin/showcase/:slug/update/',
      name: 'site-admin-showcase-update',
      component: ProcessingSteps,
      props: { isSiteAdmin: true }
    },
    {
      path: '/site-admin/showcase-templates/create/',
      name: 'site-admin-showcase-templates-create',
      component: ShowcaseTemplateEdit
    },
    {
      path: '/site-admin/showcase-templates/',
      name: 'site-admin-showcase-templates',
      component: ShowcaseTemplatesTable
    },
    {
      path: '/site-admin/showcase-templates/:id/update/',
      name: 'site-admin-showcase-templates-update',
      component: ShowcaseTemplateEdit
    },
    {
      path: '/account/showcase/:slug/update/',
      name: 'account-showcase-update',
      component: ProcessingSteps
    },
    {
      path: '/site-admin/showcase/',
      name: 'site-admin-showcase-table',
      component: ShowcasePageTable
    },
    {
      path: '/showcase/:slug',
      name: 'public-showcase',
      component: PublicShowcase
    },
    {
      path: '/showcase/:slug/?preview_token=:previewToken',
      name: 'showcase-preview',
      component: PublicShowcase
    },
    {
      path: '/project/:projectSlug',
      name: 'project-detail',
      component: ExploreDetail
    },
    {
      path: '/showcase/:slug/widget',
      name: 'public-showcase-widget',
      component: PublicShowcase
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

let initialLoad: { route: Route; pageTitle: string } = null

router.afterEach((to) => {
  if (!initialLoad) {
    initialLoad = { route: to, pageTitle: document.title }
  }

  Vue.nextTick(() => {
    if (to.meta?.title) {
      document.title = to.meta.title
    } else if (initialLoad?.route.name === to.name) {
      document.title = initialLoad.pageTitle
    }
  })
})

export default router
